import { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import dataTableData from "./data/dataTableData";
import { RequestService } from "services/RequestService";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDBadge from "components/MDBadge";
import MDProgress from "components/MDProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate, useLocation } from "react-router-dom";
import Icon from "@mui/material/Icon";
import CustomNavbar from "components/CustomNavbar";

function MilestonesDataTables() {
  const navigate = useNavigate();
  const location = useLocation();
  const [dataTableData2, setDataTableData] = useState(dataTableData);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [milestoneIdToDelete, setmilestoneIdToDelete] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);
  const [projectName, setProjectName] = useState("");

  const handleOpenDialog = (id) => {
    setmilestoneIdToDelete(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setmilestoneIdToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (milestoneIdToDelete) {
      try {
        const result = await RequestService.delete(`Milestone/${milestoneIdToDelete}/${id}`);
        if (result.status === 200) {
          toggleSnackbar();
          fetchMilestones();
        } else {
          toggleSnackbar2();
        }
      } catch (error) {
        console.error("Error deleting milstone:", error);
        toggleSnackbar2();
      }
      handleCloseDialog();
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      0: { color: "info", label: "على المسار" },
      1: { color: "error", label: "متأخر" },
      2: { color: "warning", label: "متوقف" },
      3: { color: "success", label: "منتهي" }
    };

    const config = statusConfig[status] || { color: "default", label: "غير معروف" };

    return (
      <MDBadge
        variant="gradient"
        color={config.color}
        size="sm"
        badgeContent={config.label}
        container
      />
    );
  };

  const fetchMilestones = async () => {
    try {
      const response = await RequestService.get(`Milestone/Project/${id}`);
      if (response.data.error === false) {
        const projectData = response.data.data.map((milestone, index) => {
          setProjectName(milestone.projectName);
          // Add badges for status and convert progress to MDProgress
          milestone.status = getStatusBadge(parseInt(milestone.status));
          const progressValue = parseInt(milestone.progress);
          milestone.progress = (
            <MDBox width="8rem">
              <MDProgress
                value={progressValue}
                color={progressValue === 100 ? "success" : "info"}
                variant="gradient"
                label={true}
              />
            </MDBox>
          );
          milestone.actions = (
            <MDBox display="flex" alignItems="center" gap={1}>
               <MDButton
                variant="gradient"
                color="info"
                size="small"
                onClick={() => {
                  navigate(`/pages/projects/milestones/edit?id=${milestone.id}&projectId=${id}`);
                }}
                startIcon={<Icon>edit</Icon>}
              >
                تعديل
              </MDButton>
              <MDButton
                variant="outlined"
                color="error"
                size="small"
                onClick={() => handleOpenDialog(milestone.id)}
                startIcon={<Icon>delete</Icon>}
              >
                حذف
              </MDButton>
             
            </MDBox>
          );
          milestone["#"] = index + 1;
          return milestone;
        });

        setDataTableData((prevState) => ({
          ...prevState,
          rows: projectData,
        }));
      }
    } catch (error) {
      console.error("Error fetching milestones:", error);
    }
  };

  useEffect(() => {
    setProjectId(id);
    fetchMilestones();
  }, []);

  return (

    <DashboardLayout>
      
      <CustomNavbar
        title={`مراحل مشروع ${projectName}`}
        route={[
          { path: "pages/projects/viewprojects", display: "المشاريع" },
          { path: `projectinfo?id=${id}`, display: projectName },
          { path: id, display: "تفاصيل المشروع" }
        ]}
      />
      
      <MDSnackbar
        color="success"
        icon="notifications"
        title="تم اتمام العملية"
        content="تم اتمام العملية بنجاح"
        dateTime="منذ 0 ثانية"
        open={show}
        close={toggleSnackbar}
      />

      <MDSnackbar
        color="error"
        icon="notifications"
        title="اضافة "
        content="حدث خطأ ما"
        dateTime="منذ 0 ثانية"
        open={error}
        close={toggleSnackbar2}
      />
    
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox p={3} lineHeight={1} display="flex" flexDirection="column">
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <MDTypography variant="h5" fontWeight="medium">
                مراحل المشروع
              </MDTypography>
              <MDButton
                onClick={() => {
                  navigate(`/pages/projects/milestones/add?projectId=${id}`);
                }}
                color="info"
                variant="gradient"
                size="small"
              >
                اضافة مرحلة جديدة
              </MDButton>
            </MDBox>
            
            <MDBox 
              display="flex" 
              flexDirection="column" 
              bgcolor="grey.100" 
              p={2} 
              borderRadius="lg"
            >
              <MDBox display="flex" alignItems="center" mb={1}>
                <MDTypography variant="h6" fontWeight="medium" color="text">
                  اسم المشروع:
                </MDTypography>
                <MDTypography variant="h6" fontWeight="regular" ml={1}>
                  {projectName}
                </MDTypography>
              </MDBox>

              <MDBox>
                <MDTypography variant="button" color="text" fontWeight="regular">
                  حالة المراحل:
                </MDTypography>
                <MDBox display="flex" gap={1} mt={0.5}>
                  {getStatusBadge(0)}
                  {getStatusBadge(1)}
                  {getStatusBadge(2)}
                  {getStatusBadge(3)}
                </MDBox>
              </MDBox>
            </MDBox>
          </MDBox>

          <DataTable
            table={{
              ...dataTableData2,
              customRowAttrs: true,
            }}
            canSearch
          />
        </Card>
      </MDBox>
      <Footer />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="confirm-delete-dialog-title"
      >
        <DialogTitle id="confirm-delete-dialog-title">تأكيد الحذف</DialogTitle>
        <DialogContent>
          <DialogContentText>سيتم حذف بيانات هذا الحقل بشكل نهائي. هل أنت متأكد؟</DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleConfirmDelete} color="error">
            نعم
          </MDButton>
          <MDButton onClick={handleCloseDialog} color="secondary">
            لا
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>

  );
}

export default MilestonesDataTables;
